import React, { useEffect, useState } from "react";
import { Row, Container, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import UserShopProfile from "../../components/UserShopProfile/UserShopProfile";
import UserPropertyItems from "../../components/UserProperty/UserPropertyItems";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { FailedNotify, SuccessNotify } from "../../constants/tostify";
import BackArrow from "../../components/backArrow";
// RTK Query hooks
import {
  useGetCompanyByIdQuery,
  useCreateHelpMutation,
} from "../../features/user/userApiSlice";
import { useGetPropertiesByCompanyIdQuery } from "../../features/property/propertyApiSlice";
import { extractIdFromSlug } from "../../utils/slugUtils";

const UserPeronalProperty = () => {
  const navigate = useNavigate();
  const { id: slugId } = useParams(); // company id from URL
  const id = extractIdFromSlug(slugId);

  const { name } = useSelector((state) => state.user);
  const imageUrl = useSelector((state) => state.imgurl);

  // States
  const [lgShowreport, setLgShowreport] = useState(false);

  const [createShop, setCreateShop] = useState({
    userid: name?._id,
    username: name?.fullname,
    imgurl: name?.imageUrl,
    problem: "",
    desciription: "",
    image: [""],
  });

  /* ======================
     Update image from redux
  ====================== */
  useEffect(() => {
    setCreateShop((prev) => ({
      ...prev,
      image: imageUrl?.imgurl || "",
    }));
  }, [imageUrl]);

  /* ======================
     RTK Query: Fetch Company Profile
  ====================== */
  const { data: companyData, isLoading: companyLoading } =
    useGetCompanyByIdQuery(id, { skip: !id });

  const shopData = companyData?.data?.Company || null;

  /* ======================
     RTK Query: Fetch Property Items
  ====================== */
  const { data: propertyData, isLoading: itemsLoading } =
    useGetPropertiesByCompanyIdQuery(id, { skip: !id });

  const propertyItems = propertyData?.data?.Companies || [];

  /* ======================
     RTK Mutation: Report / Help Form
  ====================== */
  const [createHelp] = useCreateHelpMutation();

  const PostShopDatas = async (e) => {
    e.preventDefault();
    try {
      const response = await createHelp(createShop).unwrap();
      if (response?.success) {
        setLgShowreport(false);
        setTimeout(() => {
          SuccessNotify("Form Property Shop Created Successfully");
          navigate(`/user-personal-property/${id}`);
        }, 1000);
      }
    } catch {
      FailedNotify("Failed To Create Shop");
    }
  };

  return (
    <Container>
      <Row>
      
        

        {/* ================= LEFT PROFILE ================= */}
        <Col lg="4" className="screenHeight">
        <Col xs="12" className="d-lg-none mb-2">
          <BackArrow mystyle="pt-1 ps-2" />
        </Col>
          <div className="border b-radius height_100">
            {shopData ? (
              <UserShopProfile
                PostShopDatas={PostShopDatas}
                setCreateShop={setCreateShop}
                lgShowreport={lgShowreport}
                setLgShowreport={setLgShowreport}
                shopData={shopData}
                id={slugId}
                shopid={id}
              />
            ) : (
              <Skeleton height={400} />
            )}
          </div>
        </Col>

        {/* ================= RIGHT PROPERTY ITEMS ================= */}
        <Col lg="8" className="screenHeight">
          <div className="border b-radius">
            {/* DESKTOP: Back arrow right box ke andar */}
            <div className="d-none d-lg-block">
              <BackArrow mystyle="pt-1 ps-2" />
            </div>

            {itemsLoading ? (
              <Skeleton
                count={5}
                height={120}
                style={{ marginBottom: "10px" }}
              />
            ) : (
              <UserPropertyItems
                shopid={id}
                itemData={{ itemdata: propertyItems }}
                shopData={shopData}
              />
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default UserPeronalProperty;